import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../booking/models/app-state.interface';
import moment from 'moment';
import { take } from 'rxjs/operators';

declare var exponea: any;

@Component({
  selector: 'app-post-office-lookup',
  templateUrl: './post-office-lookup.component.html',
  styleUrls: ['./post-office-lookup.component.scss']
})
export class PostOfficeLookupComponent implements OnInit {

  @Input() items;
  @Input() appCopy;
  @Input() selectedLanguage;

  @Output() handleSelection:EventEmitter<any> = new EventEmitter();

  public showLoader = false;
  public current = 0;
  public postOfficeLocations = [];
  public locationItem = '';

  constructor(private _appStore: Store<AppState>) { }

  ngOnInit(): void {
    this.postOfficeLocations = [...this.items];
    // exponea
    if (this.items.length > 0) {
      const state = this.getState(this._appStore);
      const flightDepartureDate = state.flightReducer.flightDetails.flightResponse?.flightInfo?.requestedDateTime || '';
      // const selectedGroup = state.timeslotReducer.selectedGroup;
      // let selectedTimeslotDateTime = ''
      // if (selectedGroup?.dateTime) {
      //   const d = moment(selectedGroup.dateTime);
      //   const t = selectedGroup.timeslots[0].startTime.split(':')
      //   d.set({
      //     hour: t[0],
      //     minute: t[1],
      //     second: 0,
      //     millisecond: 0,
      //   });

      //   selectedTimeslotDateTime = d.format("YYYY-MM-DDTHH:mm:ss");
      // }

      const locationData = state.currentBookingReducer.currentBooking.bookingJourney[0].collectionLocation;
      exponea.track('hubdrop_selection', {
        flight_departure_date: flightDepartureDate,
        // drop_off_date: selectedTimeslotDateTime, we cannot send drop off date before timeslot selection
        post_office_total_count: this.items.length,
        post_office_min_distance: this.items[0]?.distance,
        post_office_min_name: this.items[0]?.name,
        post_office_max_distance: this.items[this.items.length - 1]?.distance,
        post_office_max_name: this.items[this.items.length - 1]?.name
      });

    }

  }

  isCurrent(index) {
    return this.current === index;
  }

  valueChange(value) {
    const q = value.trim().toLowerCase();
    this.postOfficeLocations = this.items.filter(item => item.addressLine1.toLowerCase().includes(q) || item.addressLine2.toLowerCase().includes(q));
  }

  setCurrent(index) {
    this.current = index;
  }

  clearInput() {
    this.locationItem = '';
    this.valueChange('');
  }

  selectItem() {
    const selectedItem = this.items[this.current];
    this.onSelection(selectedItem);
  }

  updateSelection(e) {

    // down key
    if (e.which === 40) {
      this.current = (this.current + 1) % this.items.length;
    } else if (e.which === 38) {
      // up key
      this.current = (this.current ? this.current : this.items.length) - 1;
    } else if (e.which === 13) {
      // enter key
      e.preventDefault();
      this.selectItem();
    }

  }

  onSelection(item) {
    this.handleSelection.emit(item);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }
}
